import React from 'react';
import Navbar from "./components/Navbar";
import Gallery from "./components/Gallery";

const App = () => {
    return (
        <div className={'bg-[#2d2d2d]'}>
            <Gallery/>
        </div>
    );
};

export default App;